import { createBrowserRouter, Navigate } from 'react-router-dom';

import { SignInPage } from '@/modules/auth';
import { MainTemplate } from '@/modules/common/templates';
import { EventDetailsPage, EventsV2Page } from '@/modules/events';
import { EventDetailsTab } from '@/modules/events/constants';
import { GcrDetailsPage, GcrsPage, NewGcrPage } from '@/modules/gcrs';
import { InstanceManagerPage } from '@/modules/instances';
import { MaskDetailsPage, MasksPage, NewMaskPage } from '@/modules/masks';
import { ModelDetailsPage, ModelsPage, NewModelPage } from '@/modules/models';
import {
  ModelSizeDetailsPage,
  ModelSizesPage,
  NewModelSizePage,
} from '@/modules/model-sizes';
import {
  NewOverlayPage,
  OverlayDetailsPage,
  OverlaysPage,
} from '@/modules/overlays';
import { LegalPage } from '@/modules/privacy-policy';
import { NewStylePage, StyleDetailsPage, StylesPage } from '@/modules/styles';
import { DownloadsPage } from '@/modules/downloads';
import { NotificationTemplatesPage } from '@/modules/notification-templates';
import { NewSystemPromptPage, SystemPromptsPage } from '@/modules/system-prompts';
import {
  NewTextStylePage,
  TextStyleDetailsPage,
  TextStylesPage,
} from '@/modules/text-styles';

import { Routes } from './routes';

export const router = createBrowserRouter([
  {
    path: '*',
    element: <div>Not Found</div>,
  },
  {
    path: Routes.SignIn,
    element: <SignInPage />,
  },
  {
    path: Routes.PrivacyPolicy,
    element: <LegalPage />,
  },
  {
    path: Routes.Home,
    element: <MainTemplate />,
    children: [
      {
        path: '*',
        element: <div>Not Found</div>,
      },
      {
        path: Routes.Models,
        element: <ModelsPage />,
      },
      {
        path: Routes.ModelSizes,
        element: <ModelSizesPage />,
      },
      {
        path: Routes.NewModelSize,
        element: <NewModelSizePage />,
      },
      {
        path: Routes.ModelSizeDetails,
        element: <ModelSizeDetailsPage />,
      },
      {
        path: Routes.ModelDetails,
        element: <ModelDetailsPage />,
      },
      {
        path: Routes.NewModel,
        element: <NewModelPage />,
      },
      {
        path: Routes.Styles,
        element: <StylesPage />,
      },
      {
        path: Routes.NewStyle,
        element: <NewStylePage />,
      },
      {
        path: Routes.StyleDetails,
        element: <StyleDetailsPage />,
      },
      {
        path: Routes.Masks,
        element: <MasksPage />,
      },
      {
        path: Routes.MaskDetails,
        element: <MaskDetailsPage />,
      },
      {
        path: Routes.NewMask,
        element: <NewMaskPage />,
      },

      {
        path: Routes.Events,
        element: <EventsV2Page />,
      },
      {
        path: `${Routes.EventDetails}/:tab`,
        element: <EventDetailsPage />,
      },
      {
        path: `${Routes.EventDetails}`,
        element: <Navigate to={EventDetailsTab.Info} replace />,
      },
      {
        path: Routes.Overlays,
        element: <OverlaysPage />,
      },
      {
        path: Routes.NewOverlay,
        element: <NewOverlayPage />,
      },
      {
        path: Routes.OverlayDetails,
        element: <OverlayDetailsPage />,
      },
      {
        path: Routes.InstancesManager,
        element: <InstanceManagerPage />,
      },
      {
        path: Routes.Gcrs,
        element: <GcrsPage />,
      },
      {
        path: Routes.NewGcr,
        element: <NewGcrPage />,
      },
      {
        path: Routes.GcrDetails,
        element: <GcrDetailsPage />,
      },
      {
        path: Routes.SystemPrompts,
        element: <SystemPromptsPage />,
      },
      {
        path: Routes.SystemPromptsNewPrompt,
        element: <NewSystemPromptPage />,
      },
      {
        path: Routes.TextStyles,
        element: <TextStylesPage />,
      },
      {
        path: Routes.NewTextStyle,
        element: <NewTextStylePage />,
      },
      {
        path: Routes.TextStyleDetails,
        element: <TextStyleDetailsPage />,
      },
      {
        path: Routes.NotificationTemplates,
        element: <NotificationTemplatesPage />,
      },
      {
        path: Routes.Downloads,
        element: <DownloadsPage />,
      },
    ],
  },
]);
